import styled, { css } from 'styled-components';

export default styled.label`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  margin-bottom: .5rem;
  background-color: ${({ theme }) => theme.backgroundColor};
  border: 1px solid ${({ theme }) => theme.grayLightColor};
  border-radius: .25rem;
  padding: 1rem .5rem;
  font-size: 0.875rem;
  font-weight: 600;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    flex-direction: row;
  }

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    flex-direction: column;
  }

  ${({ $checked }) => $checked && css`
    background-color: ${({ theme }) => theme.primaryColor};
    border-color: ${({ theme }) => theme.primaryColor};
    color: white;
  `}
  &:focus-within {
    box-shadow: 0px 0px 3px blue;
  }
`;
